var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.titles, function (item, i) {
        return [
          i < 3 && item.num && _vm.activeInfo
            ? _c(
                "title-block",
                { key: i, attrs: { id: "bm" + item.label } },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mt-10" },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.tableDatas(item.moduleId),
                            "header-cell-style": {
                              background: "#fafafa",
                              color: "#333",
                            },
                            "tooltip-effect": "light",
                          },
                        },
                        [
                          _vm._l(
                            _vm.tableFields(item.moduleId),
                            function (item1, j) {
                              return [
                                item1.field != "rk"
                                  ? _c("el-table-column", {
                                      key: j,
                                      attrs: {
                                        label: item1.fieldName,
                                        align: "center",
                                        "show-overflow-tooltip": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                item1.fieldName == "二维码"
                                                  ? [
                                                      _vm.isEmpty(scope.row[j])
                                                        ? _c("span", [
                                                            _vm._v("--"),
                                                          ])
                                                        : _c(
                                                            "el-popover",
                                                            {
                                                              attrs: {
                                                                placement:
                                                                  "left",
                                                                "popper-class":
                                                                  "auto-width",
                                                                trigger:
                                                                  "hover",
                                                                width: "auto",
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "qrcode-img",
                                                                attrs: {
                                                                  src: scope
                                                                    .row[j],
                                                                },
                                                              }),
                                                              _c("img", {
                                                                staticClass:
                                                                  "qr-code-holder",
                                                                attrs: {
                                                                  slot: "reference",
                                                                  src: "/static/image/qrcode.png",
                                                                },
                                                                slot: "reference",
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  : [
                                                      _vm.whichType(
                                                        scope.row[j]
                                                      ) === "string"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.columnValue(
                                                                  scope.row[j],
                                                                  item.moduleId
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.whichType(
                                                            scope.row[j]
                                                          ) === "object"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.columnValue(
                                                                  scope.row[j],
                                                                  item.moduleId
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm.whichType(
                                                            scope.row[j]
                                                          ) === "img"
                                                        ? _c("span", [
                                                            _c("img", {
                                                              staticStyle: {
                                                                width: "100%",
                                                                "max-width":
                                                                  "64px",
                                                              },
                                                              attrs: {
                                                                src: _vm.columnValue(
                                                                  _vm.repliceHttps(
                                                                    scope.row[j]
                                                                  ),
                                                                  item.moduleId
                                                                ),
                                                                alt: "",
                                                                srcset: "",
                                                              },
                                                            }),
                                                          ])
                                                        : _vm.whichType(
                                                            scope.row[j]
                                                          ) === "url"
                                                        ? _c("span", [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: scope
                                                                    .row[j],
                                                                  target:
                                                                    "_blank",
                                                                  rel: "noopener noreferrer",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.columnValue(
                                                                      scope.row[
                                                                        j
                                                                      ],
                                                                      item.moduleId
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ])
                                                        : _vm.isEmpty(
                                                            scope.row[j]
                                                          ) &&
                                                          i == 3 &&
                                                          item1.fieldName ==
                                                            "产品logo"
                                                        ? _c("span", [
                                                            _c("img", {
                                                              staticStyle: {
                                                                width: "100%",
                                                                "max-width":
                                                                  "64px",
                                                              },
                                                              attrs: {
                                                                src: require("@/assets/defalut-img.png"),
                                                                alt: "",
                                                              },
                                                            }),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.columnValue(
                                                                  scope.row[j],
                                                                  item.moduleId
                                                                ) || "--"
                                                              ) + " "
                                                            ),
                                                          ]),
                                                    ],
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                      _c("pagination", {
                        attrs: {
                          pageNum: _vm.tablePage(item.moduleId),
                          total: _vm.tableTotal(item.moduleId),
                        },
                        on: {
                          currentChange: function (val) {
                            return _vm.handleCurrentChange(val, i)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      }),
      _vm.titles[3].num
        ? _c(
            "title-block",
            { attrs: { id: "bm科创分" } },
            [
              _c("template", { slot: "title" }, [_vm._v("科创分")]),
              _c("EnterpriseScience"),
            ],
            2
          )
        : _vm._e(),
      _vm.titles[4].num
        ? _c(
            "title-block",
            { attrs: { id: "bm新闻舆情" } },
            [
              _c("template", { slot: "title" }, [_vm._v("新闻舆情")]),
              _c(
                "el-scrollbar",
                {
                  ref: "scrollbar",
                  style: _vm.newsList.length > 3 ? "height:730px;" : null,
                  attrs: {
                    "wrap-class":
                      "scrollbar-wrapper scrollbar-wrapper-maxheight",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "infinite-scroll",
                          rawName: "v-infinite-scroll",
                          value: _vm.load,
                          expression: "load",
                        },
                      ],
                      staticClass: "mr-16",
                      attrs: { "infinite-scroll-disabled": "disabled" },
                    },
                    [
                      _vm._l(_vm.newsList, function (item, i) {
                        return _c("NewsDocument", {
                          key: item.id,
                          attrs: { data: item },
                        })
                      }),
                      _vm.loading
                        ? _c("p", { staticClass: "text-aline mb-16" }, [
                            _vm._v("加载中..."),
                          ])
                        : _vm._e(),
                      _vm.newsList.length && _vm.noMore
                        ? _c("p", { staticClass: "text-aline mb-16" }, [
                            _vm._v("- 没有更多了 -"),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }